import { __ } from '@wordpress/i18n'
import { HeaderIcon } from '~cartzillagb/icons'
import {  i18n } from 'cartzillagb'

import save from './save'
import edit from './edit'

const schema = {
    uniqueClass: {
        type: 'string',
    },
    className: {
        type: 'string',
    },

    keywordsPlaceholderText: {
        type: 'string',
        default: 'Start your search',
    },
    dropdownText: {
        type: 'string',
        default: 'All categories',
    },
    
}

export const name = 'czgb/hero-search-form'

export const settings = {
    title: __( 'Hero Search Form', i18n ),
    description: __( 'Your Hero Search Form. Use this to user search products.', i18n ),
    icon: HeaderIcon,
    category: 'cartzillagb',
    example: {},
    keywords: [
        __( 'Hero Search Form', i18n ),
        __( 'CartzillaGb', i18n ),
    ],
    supports: {
        inserter: false,
        // inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
    },
    attributes: schema,
    edit,
    save,

    // CartzillaGB modules.
    modules: {
        'advanced-responsive': true,
    },
}

